import { render, staticRenderFns } from "./StockistSection.vue?vue&type=template&id=4b9614ba&"
import script from "./StockistSection.vue?vue&type=script&lang=js&"
export * from "./StockistSection.vue?vue&type=script&lang=js&"
import style0 from "./StockistSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports